<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="funny-and-satirical">
<div class="section level2" id="coolblueice">
<h2>Coolblueice</h2>
<p>That is mighty refreshing, Griswold. Why thank you, Huber. A secret recipe handed down from generation to generation of the Zinkle family. I bet they were a fun bunch of people, too. They were and still are, if I don’t say so myself. On occasion you seem a bit stuffy but for the most part, lively. Well, if that’ isn’t a bit of assurance, Huber! So, what’s on tap for today? I reckon I will trek down to the gully and get myself some old and worn-out tires and make them new again. That sounds like some business but how come I never see anybody at your shop, Gris? It’s a specialized market that takes the bad stuff and makes it good. Yeah? Yeah! For example, you see that tire over, the blue one? Yes, but why blue? Why be the same when you can be different. I clean them up, patch here and there, and give a fresh coat of rubber with a blue sparkle shine. But I never see any blue tires around. Like I said, it’s SPECIALIZED! Oh, I see! Folks like the mundane and boring. But why be different with a blue tire? When you get a cut on your finger, Huber, what do you do? I clean it up and put a band aid on. Okay. Would it be a rubber band aid? Yes, but…Yes nothing! It heals and we go on to the next bruise, and the next one, and so forth and so on. The problem with folks nowadays is the feeling of invincibility and sameness. We all have to have the “I” whatever or the same tattoo or all go to the same spa. All the same. All the black and white. All the everything. Be different. Be unique. Be the one to think out the box. Think of things and I pardon the expression, out of the blue, Huber. Point taken Griswold. Oh by the way, your next project Gris my old boy? Well, I don’t know yet, but you kinda’ look a little pale. I got some orange paint…I gotta go Griswold. Huh? Where? Joe’s Hardware for some invisible paint thinner! Wiseacre!</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0012.vue?de976d5c